import React from "react";

export default function OnboardingConfirmation({ submittedData, onNewRequest, onViewHistory }) {
  const {
    transactionNumber,
    displayName,
    userPrincipalName,
    employeeId,
    contactNumber,
    startDate,
    employeeType,
    department,
    jobTitle,
    manager,
    location,
    office,
    address,
    district,
    region,
    applications,
    dateSubmitted,
    executionStatus,
  } = submittedData;

  const isPendingLicense = executionStatus === "Pending License";

  const formattedSubmitted = dateSubmitted
    ? new Date(dateSubmitted).toLocaleString("en-US", {
        dateStyle: "medium",
        timeStyle: "short",
      })
    : "—";

  const formattedStart = startDate
    ? (() => {
        const d = new Date(startDate.split("T")[0] + "T12:00:00");
        return isNaN(d) ? "—" : d.toLocaleDateString("en-US", { dateStyle: "medium" });
      })()
    : "—";

  const DetailRow = ({ label, value }) =>
    value ? (
      <div className="detail-row">
        <span className="detail-label">{label}</span>
        <span className="detail-value">{value}</span>
      </div>
    ) : null;

  return (
    <div className="confirmation-page">
      <div className="confirmation-card" style={{ maxWidth: 600 }}>
        <div className="confirmation-icon">
          <svg width="56" height="56" viewBox="0 0 56 56" fill="none">
            <circle cx="28" cy="28" r="28" fill="#e6f4ea" />
            <path
              d="M18 28 L25 35 L38 21"
              stroke="#1e7e34"
              strokeWidth="3"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>

        <h2>Request Submitted</h2>
        <p className="confirmation-subtitle">
          {isPendingLicense
            ? "The Entra ID account has been created. Automation is paused pending license approval — an email was sent to IT."
            : "The onboarding request has been processed. A confirmation email with the temporary password has been sent to you."}
        </p>

        {isPendingLicense && (
          <div className="pending-license-notice">
            <strong>Pending License Approval</strong>
            <p>IT needs to purchase the required license. Once approved, the automation will resume automatically.</p>
            <p>
              You can check the live status in SharePoint:{" "}
              <a href="https://serveubrands.sharepoint.com/sites/Automation/Lists/OnboardingApp" target="_blank" rel="noopener noreferrer">
                Automation site &gt; OnboardingApp list
              </a>
            </p>
          </div>
        )}

        <div className="transaction-badge">
          <span className="transaction-label">Transaction Number</span>
          <span className="transaction-number">{transactionNumber}</span>
        </div>

        <div className="confirmation-details" style={{ textAlign: "left" }}>
          <DetailRow label="Name" value={displayName} />
          <DetailRow label="UPN" value={userPrincipalName} />
          <DetailRow label="Employee ID" value={employeeId} />
          <DetailRow label="Contact #" value={contactNumber} />
          <DetailRow label="Employee Type" value={employeeType} />
          <DetailRow label="Start Date" value={formattedStart} />
          <DetailRow label="Department" value={department} />
          <DetailRow label="Job Title" value={jobTitle} />
          <DetailRow label="Manager" value={manager} />
          <DetailRow label="Location" value={location} />
          <DetailRow label="Office" value={office} />
          <DetailRow label="Address" value={address} />
          <DetailRow label="District" value={district} />
          <DetailRow label="Region" value={region} />
          <DetailRow label="Applications" value={applications} />
          <DetailRow label="Submitted" value={formattedSubmitted} />
        </div>

        <div className="confirmation-actions">
          <button className="btn-secondary" onClick={onViewHistory}>
            View History
          </button>
          <button className="btn-primary" onClick={onNewRequest}>
            Submit Another Request
          </button>
        </div>
      </div>
    </div>
  );
}
